import io from 'socket.io-client';
import feathers from '@feathersjs/client';
import authLib from '../lib/auth';

import auth from './auth';
import buildings from './buildings';
import facilities from './facilities';
import floors from './floors';
import infographics from './infographics-setup';
import invitations from './invitations';
import markerTypeCategories from './marker-type-categories';
import markerTypes from './marker-types';
import markers from './markers-setup';
import users from './users/users-setup';
import groups from './groups';
import permissions from './permissions';
import currentAccount from './currentAccount/currentAccount-setup';
import plans from './plans';
import trainingTutorials from './training-tutorials';
import sessions from './sessions';

import { skippable } from './hooks';

const socket = io(process.env.REACT_APP_API_URL, {
  transports: ['websocket'],
  forceNew: true
});

const app = feathers();
app.configure(feathers.socketio(socket, {
  timeout:Number.parseInt(process.env.REACT_APP_SOCKET_TIMEOUT, 10)
}));

app.configure(auth);

app.configure(buildings);
app.configure(facilities);
app.configure(floors);
app.configure(infographics);
app.configure(invitations);
app.configure(markerTypeCategories);
app.configure(markerTypes);
app.configure(markers);
app.configure(users);
app.configure(groups);
app.configure(permissions);
app.configure(currentAccount);
app.configure(plans);
app.configure(trainingTutorials);
app.configure(sessions);

// After all calls, if is not authed, delete the token
// and redirect to the login page with a full page reload
// to purge any data in memory.
const redirectUnAuthed = skippable('redirectUnAuthed', context => {
  if (context.error.code === 401) {
    authLib.logOut();
  }
});

// Hooks run on all services
app.hooks({
  error: { all: [redirectUnAuthed] }
});

export default app;



// WEBPACK FOOTER //
// ./src/feathers/index.js